import { Link } from 'react-router-dom';
import { categories, posts } from '@/mocks/posts';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-primary-600 uppercase mb-3">
              <i className="ri-subtract-line" />
              主题分类
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">按看点方向找内容</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-7">
              把高能名场面拆成五个方向，想看球就看球，想磕剧就磕剧，不必在信息流里反复翻找。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category) => {
            const count = posts.filter((post) => post.categorySlug === category.slug).length;
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group relative h-56 md:h-64 overflow-hidden rounded-lg bg-background-200"
              >
                <img
                  src={category.cover}
                  alt={`${category.name}看点合集`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent" />
                <div className="relative z-10 h-full p-5 flex flex-col justify-end">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                      <i className={category.icon} />
                    </span>
                    <span className="text-xs text-background-100/70">{count} 期合集</span>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl text-background-50">{category.name}</h3>
                  <p className="mt-2 text-xs md:text-sm text-background-100/75 leading-6 line-clamp-2">
                    {category.desc}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                    进入分类
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}